import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-verify-email-pending',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    RouterModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  templateUrl: './verify-email-pending.component.html',
  styleUrl: './verify-email-pending.component.scss'
})
export class VerifyEmailPendingComponent implements OnInit {
  resending = false;
  resent = false;
  emailForm: FormGroup;

  constructor(
    private route: ActivatedRoute,
    private auth: AuthService,
    private fb: FormBuilder,
  ) {
    this.emailForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  ngOnInit(): void {
    // Only a hint when the caller could confirm it looked like a real email —
    // still editable, since that guess can be wrong (e.g. login accepts a
    // username too, which isn't necessarily the account's email address).
    const prefill = this.route.snapshot.queryParamMap.get('email');
    if (prefill) {
      this.emailForm.patchValue({ email: prefill });
    }
  }

  async resend(): Promise<void> {
    if (!this.emailForm.valid) {
      return;
    }
    this.resending = true;
    try {
      await this.auth.resendVerificationEmail(this.emailForm.value.email);
      this.resent = true;
    } finally {
      this.resending = false;
    }
  }
}
